const map = {
	"./avatar-1.jpg": 1162,
	"./avatar-2.jpg": 6885,
	"./avatar-3.jpg": 2568,
	"./avatar-4.jpg": 9307,
	"./avatar-5.jpg": 8881,
	"./caremePrivacy.svg": 4914,
	"./logo-menu-colapsado.svg": 9021,
	"./logoCaremeLogin.svg": 746,
	"./memphis-colorful.png": 7025
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;